import Session from '../auth/Session';
import AuthFunctions from '../services/AuthService';

const AdminFunctions = {
    isAdminAsync: async function () {
        const token = Session.getToken();
        const response = await fetch(`api/Admin/IsAdminAsync`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        if (response.status === 401) {
            const isauthenticated = await AuthFunctions.getAuthenticatedAsync();

            if (isauthenticated) {
                Session.removeUserSession();
                window.location.href = '/login';
                return false;
            } else {
                window.location.href = '/login';
                return false;
            }
        } else {
            const data = response.json();
            return data;
        }
    },
    handleAdminUser: async function(isAdmin, adminFunction, nonAdminFunction) {
        if(isAdmin) {
            if(adminFunction){ adminFunction(); };            
        } else {
            if(nonAdminFunction){ nonAdminFunction(); };            
        }
    },
    getRoleNameAsync: async function () {
        const token = Session.getToken();
        const response = await fetch(`api/Admin/GetRoleNameAsync`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();

        return data;
    },
    getRoleIdByName: async function(name) {        
        const token = Session.getToken();
        const response = await fetch(`api/Admin/GetRoleIdByNameAsync?roleName=${name}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data.id;
    }
}

export default AdminFunctions;